import { useExport, useGetIdentity, useNavigation, useShow } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  Table,
  useTable,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  ShowButton,
  Typography,
  Tag,
  Form,
  Input,
} from '@pankod/refine-antd'

import { IEvaluationRequests } from 'interfaces'
import { CreateEvaluationRequest } from 'pages/evaluation_requests'
import { EditEvaluationRequest } from 'pages/evaluation_requests'
import { useEffect, useState } from 'react'
import Permissions from 'permissions'
import { useUserContext } from 'context/user'
import metaData from 'metadata/evaluationRequest'
type Permission = {
  granted?: boolean
}

const { PlusOutlined } = Icons
const { Text } = Typography
type ListProps = {
  request?: any
}

export const EvaluationRequestsList: React.FC<ListProps> = ({ request }) => {
  const { userRole } = useUserContext()
  const { data: user } = useGetIdentity()
  const [readPermission, setReadPermission] = useState<Permission>({})
  const [createPermission, setCreatePermission] = useState<Permission>({})
  const [editPermission, setEditPermission] = useState<Permission>({})
  const [deletePermission, setDeletePermission] = useState<Permission>({})
  const [selectedEvalReqTE, setSelectedEvalReqTE] = useState<string | undefined>(undefined)
  useEffect(() => {
    if (userRole !== undefined) {
      setReadPermission(Permissions.can(userRole).readAny('evaluation_requests'))
      setCreatePermission(Permissions.can(userRole).createAny('evaluation_requests'))
      setEditPermission(Permissions.can(userRole).updateAny('evaluation_requests'))
      setDeletePermission(Permissions.can(userRole).deleteAny('evaluation_requests'))
    }
  }, [userRole])
  const { queryResult, setShowId } = useShow<IEvaluationRequests>({
    resource: 'evaluation_requests',
    metaData: metaData,
  })
  const { data: showQueryResult } = queryResult
  const record = showQueryResult?.data
  const { tableProps, sorter, tableQueryResult, setFilters, searchFormProps } = useTable<IEvaluationRequests>({
    resource: 'evaluation_requests',
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    permanentFilter: [
      {
        field: 'test_event_id',
        operator: 'eq',
        value: request?.id,
      },
    ],
    metaData,
    defaultSetFilterBehavior: 'replace',
    onSearch(data: any) {
      const searchValue = data?.name?.trim()
      const requestIdValue = searchValue ? parseInt(searchValue, 10) : null
      return [
        {
          operator: 'or',
          value: [
            { field: 'name', operator: 'contains', value: `%${data?.name}%` },
            { field: 'request_id', operator: 'eq', value: requestIdValue && !isNaN(requestIdValue) ? requestIdValue : -1 },
          ],
        },
      ]
    },
  })
  const { show } = useNavigation()
  console.log('first', request, record)
  const {
    formProps,
    modalProps,
    show: createShow,
  } = useModalForm({
    resource: 'evaluation_requests',
    action: 'create',
    redirect: false,
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'evaluation_requests',
    action: 'edit',
    redirect: false,
    metaData,
  })

  const { triggerExport, isLoading } = useExport<IEvaluationRequests>()
  useEffect(() => {
    if (userRole === 'evaluationincharge') {
      setFilters([
        {
          field: 'evaluation_in_charge',
          operator: 'eq',
          value: user?.id,
        },
      ])
    } else if (userRole === 'deliverymanager') {
      setFilters([
        {
          field: 'created_by',
          operator: 'eq',
          value: user?.id,
        },
      ])
    } else if (userRole === 'evaluators') {
      setFilters([
        {
          field: 'evaluators.evaluator_id',
          operator: 'eq',
          value: user?.id,
        },
        {
          field: 'status',
          operator: 'ne',
          value: 'Open',
        },
      ])
    }
  }, [userRole])
  return (
    <List
      title="Evaluation Requests"
      pageHeaderProps={{
        extra: [
          //  <ExportButton onClick={triggerExport} loading={isLoading} />,
          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <>
            {request?.id ? (
              <CreateButton
                style={{ display: createPermission !== undefined && createPermission?.granted ? 'block' : 'none' }}
                type="primary"
                icon={<PlusOutlined />}
                onClick={() => {
                  createShow()
                }}
              />
            ) : null}
          </>,
        ],
      }}
    >
      {!request && (
        <Form {...searchFormProps}>
          <Space>
            <Form.Item name="name">
              <Input
                placeholder="90-eid-4671-teid-a5d"
                onChange={() => searchFormProps.form?.submit()}
                allowClear
                prefix={<Icons.SearchOutlined style={{ cursor: 'pointer' }} />}
              />
            </Form.Item>
          </Space>
        </Form>
      )}
      <Table {...tableProps} rowKey="id" size="small">
        <Table.Column
          dataIndex="name"
          title="Name"
          render={(_, record: any) => (
            <ShowButton
              size="small"
              type="link"
              icon={null}
              recordItemId={record.id}
              onClick={() => {
                show('evaluation_requests', record.id)
              }}
            >
              <Text
                style={{
                  width: 200,
                  textAlign: 'left',
                  color: '#6659FF',
                  cursor: 'pointer',
                }}
                ellipsis={{ tooltip: record?.name }}
              >
                #{record?.request_id}-{record?.name}
              </Text>
            </ShowButton>
          )}
        />
        <Table.Column
          dataIndex="slot_selected"
          title="Slot"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
        />
        <Table.Column
          dataIndex="status"
          title="Status"
          render={value => (
            <>
              <Tag color={value === 'Completed' ? 'green' : value === 'Draft' ? 'pink' : value === 'Closed' ? 'volcano' : 'geekblue'}>{value}</Tag>
            </>
          )}
        />
        <Table.Column dataIndex="paper" title="Paper" render={(_, record: any) => `#${record?.paper?.paper_id}-${record?.paper?.paper_smart_id}`} />

        <Table.Column
          dataIndex="evaluation_in_charge"
          title="Evaluation In Charge"
          render={(_, record: any) => record?.evaluationInCharge?.displayName}
        />
        <Table.Column
          dataIndex="evaluators"
          title="Evaluators"
          render={(_, record: any) => {
            return record?.evaluators?.map((evalUser: any) => (
              <Text code key={evalUser?.id}>
                {evalUser?.evaluator?.displayName}
              </Text>
            ))
          }}
        />
        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />

        <Table.Column<IEvaluationRequests>
          title="Actions"
          className={editPermission !== undefined && editPermission?.granted ? 'show' : 'hide'}
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              {editPermission !== undefined && editPermission?.granted ? (
                <EditButton
                  size="small"
                  resource="evaluation_requests"
                  type="link"
                  icon={null}
                  recordItemId={record.id}
                  onClick={() => {
                    setSelectedEvalReqTE(record?.test_event_id)
                    setShowId(record.id)
                    editShow(record.id)
                  }}
                />
              ) : null}
              {deletePermission !== undefined && deletePermission?.granted ? (
                <DeleteButton
                  resource="evaluation_requests"
                  resourceNameOrRouteName="evaluation_requests"
                  size="small"
                  type="link"
                  icon={null}
                  recordItemId={record.id}
                />
              ) : null}
            </Space>
          )}
        />
      </Table>
      <CreateEvaluationRequest modalProps={modalProps} formProps={formProps} record={request} />
      <EditEvaluationRequest modalProps={editModalProps} formProps={editFormProps} request={request ?? selectedEvalReqTE} data={record} />
    </List>
  )
}
